import React , {Component} from "react"
import LineHaulFilter from "./LineHaulFilter"
import LineHaulFilterContextProvider from "./context/LineHaulFilterContext";
import LineHaulInfo from "./LineHaulInfo";
import LineHaulContent from "./LineHaulContent";
import LineHaulDetailContextProvider from "./context/LineHaulDetailContext";
import CapabilityContextProvider from "../global/context/ConfigContext";
import Column from "@amzn/meridian/column";

class LineHaulDetail extends Component {

    render() {
        return (
            <Column spacingInset={"small large"} spacing={"medium"}>
                <LineHaulFilterContextProvider>
                    <CapabilityContextProvider>
                        <LineHaulDetailContextProvider>
                            <LineHaulInfo lineHaul = {this.props.match.params}/>
                            <LineHaulFilter/>
                            <LineHaulContent lineHaul = {this.props.match.params}/>
                        </LineHaulDetailContextProvider>
                    </CapabilityContextProvider>
                </LineHaulFilterContextProvider>
            </Column>
        )
    }
}

export default LineHaulDetail


// WEBPACK FOOTER //
// ./src/components/linehaul/LineHaulDetail.js